import React, { useEffect, useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import {
    Box,
    Button,
    ButtonBase,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
} from '@material-ui/core';
import { Player } from '@lottiefiles/react-lottie-player';
import { NO_REFETCH } from 'src/lib/utils/react-query-utils';
import {
    getScanCouponData,
    getAddCouponData,
} from 'src/lib/api-client/wallet-activities';
import useUserInfo from 'src/hooks/useUserInfo';

import { useUserUpdateContext } from 'src/lib/contexts/user-update-context';
import { Close } from '@material-ui/icons';
import ROUTES from 'src/lib/routes';
import useRouter from 'src/hooks/useRouter';
import { getCoupons } from 'src/services/easyRewardsServices';
import { CouponResponse } from 'src/services/types';
import ScannableCouponNew from './ScannableCouponNew';
import LoadingOverlay from '../loading-overlay';
import { useProductBrowseContext } from '../../lib/contexts/product-browse-context';
import { Body, Heading } from '../UI';
import Row from '../Row';
import ArrowBackIcon from '../Icons/ArrowBackIcon';
import ArrowForwordIcon from '../Icons/ArrowForwordIcon';
import useStyles from './styles';

function ScannableCouponDialogNew() {
    const classes = useStyles();
    const { userInfo, isFetchingUserInfo } = useUserInfo();
    const [showError, setShowError] = useState(false);
    const { isScannbleDeepLink, staplesScannableCouponDeepLink } =
        useUserUpdateContext();
    const { history, query } = useRouter();
    console.log('🚀 ~ ScannableCouponDialog ~ query:', query);
    const rewardsNumber = userInfo?.rewardsNumber || '0';
    const couponNumber: string | undefined = query?.couponNumber;
    const couponCode = couponNumber;
    const isRouteFromDeepLink = query?.deepLink === 'true';
    const [isSaveCouponCall, setSaveCouponCall] = useState(false);
    const [isSaveCouponFetch, setSaveCouponFetch] = useState(false);
    const [defaultIndex, setDefaultIndex] = useState<number>(0);
    const { fromPath } = useProductBrowseContext();
    // const tabIndex = query?.tabIndex;

    const filterAndSetCouponList = (couponDataList: any) =>
        couponDataList.filter(
            (coupon: any) =>
                coupon.category === 'Coupon' &&
                (!coupon?.couponInfo?.isRedeemed ||
                    coupon?.couponInfo?.couponClass.toLowerCase() ===
                        'storecredit')
        );
    const addScanCoupon = () => {
        if (couponCode?.length === 5) {
            return getScanCouponData({ rewardsNumber, couponCode });
        }
        return getAddCouponData({ rewardsNumber, couponCode });
    };

    const {
        data: response,
        isFetched,
        status,
        refetch: fetchCouponData,
    } = isRouteFromDeepLink && !isSaveCouponCall
        ? useQuery(['scanDetailsCoupons', rewardsNumber], addScanCoupon, {
              ...NO_REFETCH,
              enabled: !isFetchingUserInfo,
              onError: () => {
                  setShowError(true);
              },
          })
        : getCoupons({ rewardsNumber });

    useEffect(() => {
        if (!isScannbleDeepLink && isRouteFromDeepLink) {
            staplesScannableCouponDeepLink();
        }
    }, []);
    useEffect(() => {
        if (isSaveCouponCall) {
            fetchCouponData();
            setSaveCouponCall(false);
            setTimeout(() => {
                setSaveCouponFetch(false);
            }, 500);
        }
    }, [isSaveCouponCall]);

    const couponList: any = useMemo(() => {
        if (status === 'success' && isFetched) {
            let isCouponAvaible = true;
            const dataList =
                (response as any)?.data?.couponDataList ||
                (response as CouponResponse)?.couponDataList;
            if (isRouteFromDeepLink && couponNumber) {
                const couponNumberLength = couponNumber.length;
                if (couponNumberLength === 5) {
                    isCouponAvaible =
                        dataList?.findIndex(
                            (coupon: any) =>
                                !coupon?.couponInfo?.isRedeemed &&
                                (coupon?.couponInfo?.couponClass ===
                                    'StoreQRSingleUse' ||
                                    coupon?.couponInfo?.couponClass ===
                                        'StoreQRMultiUse' ||
                                    coupon?.couponInfo?.couponClass ===
                                        'NewUserQRCode') &&
                                couponNumber ===
                                    coupon?.couponNumber?.substring(
                                        0,
                                        couponNumberLength
                                    )
                        ) !== -1;
                } else if (couponNumberLength === 16) {
                    isCouponAvaible =
                        dataList?.findIndex(
                            (coupon: any) =>
                                !coupon?.couponInfo?.isRedeemed &&
                                coupon?.couponInfo?.couponClass ===
                                    'WebCoupon' &&
                                couponNumber ===
                                    coupon?.couponNumber?.substring(
                                        0,
                                        couponNumberLength
                                    )
                        ) !== -1;
                } else {
                    isCouponAvaible = false;
                }
            }
            if (isCouponAvaible) {
                const resData =
                    dataList?.sort((a: any, b: any) =>
                        a.couponInfo.priority > b.couponInfo.priority ? 1 : -1
                    ) || [];
                return filterAndSetCouponList(resData);
            }
            return [];
        }
        return null;
    }, [isFetched, status, response]);

    const getDefaultIndex = () => {
        if (isRouteFromDeepLink && couponNumber?.length === 5) {
            const index = couponList?.findIndex(
                (coupon: any) =>
                    !coupon?.couponInfo?.isRedeemed &&
                    (coupon?.couponInfo?.couponClass === 'StoreQRSingleUse' ||
                        coupon?.couponInfo?.couponClass ===
                            'StoreQRMultiUse') &&
                    couponNumber === coupon.couponNumber.substring(0, 5)
            );
            return index >= 0 ? index : 0;
        }
        if (isRouteFromDeepLink && couponNumber?.length === 16) {
            const index = couponList?.findIndex(
                (coupon: any) =>
                    !coupon?.couponInfo?.isRedeemed &&
                    coupon?.couponInfo?.couponClass === 'WebCoupon' &&
                    couponNumber === coupon.couponNumber.substring(0, 16)
            );

            return index >= 0 ? index : 0;
        }
        if (couponNumber) {
            const index = couponList?.findIndex(
                (coupon: any) => couponNumber === coupon.couponNumber
            );
            return index >= 0 ? index : 0;
        }
        return 0;
    };

    useEffect(() => {
        const couponIndex = getDefaultIndex();
        if (defaultIndex === 0 && couponIndex > 0) {
            setDefaultIndex(couponIndex);
        }
    }, [couponNumber]);

    const { couponInfo, couponData } = useMemo(() => {
        if (couponList && couponList.length > 0) {
            const couponDetails = couponList[defaultIndex];

            return {
                couponInfo: couponDetails.couponInfo,
                couponData: couponDetails,
            };
        }
        return { couponInfo: null, couponData: null };
    }, [defaultIndex, couponList]);

    const handleClose = () => {
        if (couponNumber) {
            if (query?.tabIndex === '1') {
                history.push(ROUTES.rewardsWallet);
            } else if (ROUTES.stores === fromPath) {
                history.push(ROUTES.stores);
            } else {
                history.push(`${ROUTES.rewardsWallet}?tabIndex=2`);
            }
        } else {
            history.push(ROUTES.home);
        }
    };
    const handleCloseNoResponsePopUp = () => {
        setShowError(false);
        history.push(ROUTES.home);
    };
    if (isRouteFromDeepLink && (couponList?.length === 0 || showError)) {
        return (
            <Dialog
                open
                onClose={handleCloseNoResponsePopUp}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">Error</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Unable to redeem coupon. Coupon not found.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseNoResponsePopUp}>Ok</Button>
                </DialogActions>
            </Dialog>
        );
    }
    return (
        <div className={classes.carouselContainer}>
            {isSaveCouponFetch && (
                <LoadingOverlay
                    variant="wordmark"
                    theme="transparent-light"
                    open
                />
            )}
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    position: 'relative',
                    px: '16px',
                    pt: '16px',
                    pb: '24px',
                }}
            >
                <Heading type="h4" size={18} weight="bold">
                    Coupon details
                </Heading>
                <Box
                    sx={{
                        position: 'absolute',
                        right: '10px',
                    }}
                >
                    <ButtonBase
                        className={classes.closeButton}
                        onClick={handleClose}
                    >
                        <Close />
                    </ButtonBase>
                </Box>
            </Box>
            {rewardsNumber && couponList ? (
                <Row
                    direction="column"
                    gap="16px"
                    sx={{ height: 'calc(100% - 66px)' }}
                >
                    <>
                        <Row
                            justifyContent={'space-between'}
                            alignItems={'center'}
                            sx={{
                                px: '16px',
                            }}
                        >
                            <>
                                <IconButton
                                    style={{
                                        backgroundColor: '#f1f1f1',
                                        color: 'inherit !important',
                                        padding: '8px',
                                    }}
                                    onClick={() => {
                                        const totalNumbers =
                                            couponList?.length - 1;
                                        if (defaultIndex === 0) {
                                            setDefaultIndex(totalNumbers);
                                        } else {
                                            setDefaultIndex((currIndex) => {
                                                if (currIndex > 0) {
                                                    return currIndex - 1;
                                                }
                                                return currIndex;
                                            });
                                        }
                                    }}
                                    // disabled={defaultIndex === 0}
                                >
                                    <ArrowBackIcon />
                                </IconButton>
                                <Body>
                                    {defaultIndex + 1}/{couponList?.length}
                                </Body>
                                <IconButton
                                    style={{
                                        backgroundColor: '#f1f1f1',
                                        color: 'inherit !important',
                                        padding: '8px',
                                    }}
                                    onClick={() => {
                                        const existingIndex = defaultIndex + 1;
                                        const totalNumbers = couponList?.length;
                                        if (existingIndex === totalNumbers) {
                                            setDefaultIndex(0);
                                        } else {
                                            setDefaultIndex((currIndex) => {
                                                if (
                                                    currIndex <
                                                    couponList?.length - 1
                                                ) {
                                                    return currIndex + 1;
                                                }
                                                return currIndex;
                                            });
                                        }
                                    }}
                                    // disabled={
                                    //     defaultIndex === couponList?.length
                                    // }
                                >
                                    <ArrowForwordIcon />
                                </IconButton>
                            </>
                        </Row>
                        {couponInfo && (
                            <ScannableCouponNew
                                rewardsNumber={rewardsNumber}
                                couponApplicable={couponInfo.couponApplicable}
                                couponNumber={couponData.couponNumber}
                                couponLimitedTime={couponInfo.isLimitedTime}
                                availableUntil={couponInfo.availableUntil}
                                expirationDate={couponInfo.expirationDate}
                                descriptionText1={couponInfo.descriptionText1}
                                descriptionText2={couponInfo.descriptionText2}
                                isSaved={couponInfo.isSaved}
                                validForDotcom={couponInfo.validForDotcom}
                                validForRetail={couponInfo.validForRetail}
                                terms={couponInfo.terms}
                                isCouponNumberDisplayed={
                                    couponData.isCouponNumberDisplayed
                                }
                                imageURL={couponInfo.imageURL}
                                setSaveCouponCall={setSaveCouponCall}
                                setSaveCouponFetch={setSaveCouponFetch}
                                couponClass={couponInfo.couponClass}
                                isClippable={couponInfo.isClippable}
                            />
                        )}
                    </>
                </Row>
            ) : (
                // <Carousel
                //     type="number"
                //     dots={couponList?.length}
                //     dotPosition="top"
                //     dotStyle={{
                //         margin: '1rem 0',
                //     }}
                //     activeColor={COLORS.brandRed}
                //     defaultIndex={
                //         defaultIndex > 0 ? defaultIndex : getDefaultIndex()
                //     }
                //     styles={{
                //         root: {
                //             flexGrow: 1,
                //             overflow: 'hidden',
                //         },
                //         containerStyle: {
                //             height: '100%',
                //             paddingBottom: 20,
                //         },
                //         slideContainer: {
                //             height: '100%',
                //             overflow: 'hidden',
                //             // padding: '0 1.5rem 1.5rem 1.5rem',
                //         },
                //     }}
                //     content={couponList?.map(couponMap)}
                //     setDefaultIndex={setDefaultIndex}
                // />
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100%',
                    }}
                >
                    <Player
                        autoplay
                        loop
                        src={require('../../assets/lotties/stapleRevealWordmark.json')}
                    />
                </div>
            )}
        </div>
    );
}

export default () => <ScannableCouponDialogNew />;
